import { useState } from 'react';
import {
	hasCheckedFolder,
	isCheckedFolder,
	FOLDER_NOT_SELECTED,
	useContentAction,
} from '@_features/content';
import { IContent, TFolder } from '@_entities/content';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import * as Modal from '@_shared/ui/Modal';
import { Typography } from '@_shared/ui/Typography';
import * as S from './FolderUpdateModal.style';

interface IProps {
	folderlist: TFolder[];
	folderId: number;
	content: IContent;
	isFolderDetailPage: boolean;
}

export function FolderUpdateModal({ folderlist, folderId, content, isFolderDetailPage }: IProps) {
	const [checkedFolderState, setCheckedFolderState] = useState<number>(folderId);
	const { popLayer } = useUILayerStore();

	const { dispatch: dispatchContentAction } = useContentAction(content);

	return (
		<Modal.Container isButton closeModal={popLayer}>
			<Modal.Header>폴더 선택</Modal.Header>
			<S.Container>
				<S.FolderList>
					{folderlist.map((folder) => (
						<S.FolderItem
							key={`${folder.id} folder button`}
							htmlFor={`${folder.id}`}
							isChecked={isCheckedFolder(checkedFolderState, folder.id)}
							onClick={() => {
								setCheckedFolderState(
									isCheckedFolder(checkedFolderState, folder.id)
										? FOLDER_NOT_SELECTED
										: folder.id,
								);
							}}
						>
							<Typography
								type="body-large"
								color={
									checkedFolderState === folder.id
										? 'warmgray-800'
										: 'warmgray-600'
								}
								noOfLine={1}
							>
								{folder.name}
							</Typography>
						</S.FolderItem>
					))}
				</S.FolderList>
			</S.Container>
			<Modal.Button
				disabled={
					!hasCheckedFolder(checkedFolderState) ||
					isCheckedFolder(checkedFolderState, folderId)
				}
				onClick={() => {
					dispatchContentAction({
						type: 'UPDATE_FOLDER',
						updatedFolderId: checkedFolderState,
					});
					popLayer();
					popLayer();
					if (isFolderDetailPage) {
						window.location.reload();
					}
				}}
			>
				확인
			</Modal.Button>
		</Modal.Container>
	);
}
